
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { CommunicationService } from '../api-users/api/communication.service';
import { CommunicationResource } from '../api-users/model/communicationResource';


@Injectable({
    providedIn: 'root'
})
export class CommunicationsService {
    private _communications: BehaviorSubject<CommunicationResource[] | null> = new BehaviorSubject<CommunicationResource[] | null>(null);

    constructor(
        private _communicationsDsService: CommunicationService
    ) {
    }

    get communications$(): Observable<CommunicationResource[] | null> {
        return this._communications.asObservable();
    }

    public getCommunications() {
        return this._communicationsDsService.getListCommunications().pipe(
            tap(communications => {
                this._communications.next(communications);
            })
        );
    }

    public searchCommunications(): Observable<CommunicationResource[]> {
        return this._communicationsDsService.getListCommunications();
    }

    public deleteCommunication(id: number): Observable<any> {
        return this._communicationsDsService.deleteCommunication(id);
    }

    public editCommunication(id: number, comm: any): Observable<any> {
        return this._communicationsDsService.updateCommunication(id, comm);
    }
}
